module.exports = __webpack_public_path__ + "static/img/again-button.1c5fc65.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/again-button.png
// module id = zOki
// module chunks = 0